module.exports = __webpack_public_path__ + "img/school.ad73cff4.svg";